import React from 'react';
import { Box, Typography } from '@mui/material';
import { LABOKLIN_BORDER } from '../../theme/laboklinTheme';

/**
 * One block of the diagnostic-support column, and the small caps label above it.
 *
 * Shared so the three panels sit on the same rhythm; there is nothing clever here.
 */

export const PanelEyebrow: React.FC<{ label: string; state?: string }> = ({ label, state }) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      mb: 1,
      gap: 1,
    }}
  >
    <Typography
      sx={{
        fontSize: 11,
        textTransform: 'uppercase',
        letterSpacing: '0.08em',
        color: 'text.secondary',
        fontWeight: 600,
      }}
    >
      {label}
    </Typography>
    {state && (
      <Typography sx={{ fontSize: 11, color: 'text.secondary', textAlign: 'right' }}>
        {state}
      </Typography>
    )}
  </Box>
);

const PanelBlock: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Box sx={{ px: 2.5, py: 2.25, borderBottom: `1px solid ${LABOKLIN_BORDER}`, '&:last-of-type': { borderBottom: 0 } }}>
    {children}
  </Box>
);

export default PanelBlock;
